var base = require('settings/teams/bulk-csv-create-users');

Vue.component('spark-bulk-csv-create-users', {
    mixins: [base]
});
